// extracted by mini-css-extract-plugin
module.exports = {"svg":"favourites_svg__FLArc","link":"favourites_link__axYHV","number":"favourites_number__VfSSr","pulse":"favourites_pulse__C_FHB","pulsing":"favourites_pulsing__gqs0W"};